$(document).ready(function() {
  var isDeliveryClicked = Cookies.get('deliveryClicked');
  $('.cr-shipping-method').on('click', function(){
    var inFifteenMinutes = new Date(new Date().getTime() + 15 * 60 * 1000);
    Cookies.set('deliveryClicked', '1', {
        expires: inFifteenMinutes
    });
  })
  
  // Click on the pickup option only if delivery was not clicked earlier
  setTimeout(function(){
    if (!isDeliveryClicked){
	    $('.js-toggle-pickup').click()
    }
  }, 500)
});